<template>
	<div>
		<nav class="navbar" role="navigation" aria-label="header navigation">
			<div class="navbar-brand">
				<div class="navbar-burger burger" @click="toggleSidebar()">
					<span />
					<span />
					<span />
				</div>

				<div class="navbar-route-name">
					<span class="view-title">
						{{ formatedTitle }}
					</span>
					<div
						id="customNavbarTitle"
						class="navbar-custom-title is-hidden-touch"
					></div>
				</div>
			</div>
			<div class="navbar-menu">
				<div class="navbar-end is-align-items-center">
					<search />
					<help-resources v-if="enableSupport" />
					<user-profile class="ml-1" />
				</div>
				<hr class="navbar-divider" v-if="isSupport" />
				<div v-if="isSupport" class="is-flex is-align-items-center">
					<router-link
						class="navbar-item pr-0"
						:to="{ name: 'user-delegated-connections' }"
					>
						<ws-button is-grey is-outlined>
							<template #icon>
								<ws-icon icon="users" />
							</template>
						</ws-button>
					</router-link>
					<impersonate-status />
				</div>
			</div>
		</nav>
		<div
			id="customNavbarTitleMobile"
			class="navbar-custom-title is-hidden-desktop"
		></div>
	</div>
</template>

<script lang="ts">
import { EventBus } from "@/eventbus.js";
import Search from "./search.vue";
import UserProfile from "./user-profile.vue";
import HelpResources from "./help-resources.vue";
import ImpersonateStatus from "./impersonate-status.vue";
import { useAuth } from "@/composables/useAuth";
import { useConsoleConfig } from "@/plugins/client-name/client-name.plugin";

export default {
	name: "Navbar",

	emits: ["isReady", "toggleSidebarMenu"],

	setup() {
		const { isSupport } = useAuth();
		const { enableSupport } = useConsoleConfig();

		return {
			isSupport,
			enableSupport
		};
	},

	data() {
		return {
			user: {},
			organization: {},
			showNavMenu: false,
			navbarTitle: ""
		};
	},

	created() {
		EventBus.$on("setNavbarTitle", this.setTitle);
	},

	mounted() {
		// when mounted, emit event
		this.$emit("isReady");
	},

	unmounted() {
		EventBus.$off("setNavbarTitle", this.setTitle);
	},

	methods: {
		setTitle(title) {
			this.navbarTitle = title;
		},

		toggleSidebar() {
			EventBus.$emit("toggleSidebarMenu");
		}
	},

	computed: {
		formatedTitle() {
			if (!this.navbarTitle) {
				return "";
			}
			return this.navbarTitle.toString().trim();
		}
	},

	components: {
		Search,
		UserProfile,
		HelpResources,
		ImpersonateStatus
	}
};
</script>

<style lang="scss" scoped>
nav.navbar {
	box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
	padding-left: 1.25rem;
	padding-right: 1.25rem;
	flex-shrink: 0;

	@include mobile {
		& {
			padding-left: 0;
			// padding-right: 0;
		}
		.navbar-burger {
			display: block;
			color: $color-grey-600;
		}

		.navbar-brand {
			flex-shrink: 1;
			align-items: flex-start;
			flex-wrap: wrap;
		}
	}

	.navbar-brand {
		flex: 1 1 auto;
		min-width: 0;
	}

	.navbar-menu {
		min-width: 0;
	}

	.navbar-route-name {
		display: flex;
		flex: 1 1 0%;
		min-width: 0;
		padding: 10px;
		padding-left: 0;
		height: 100%;
		width: 100%;
		align-items: center;

		& > span.view-title {
			display: block;
			min-width: 0;
			max-width: 100%;
			font-size: $size-5;
			font-weight: $weight-semibold;
			color: $color-grey-700;

			@include mobile {
				font-size: $size-6;
			}
		}
	}
}

.navbar-custom-title {
	display: flex;
	flex: 1 1 100%;
	min-width: 0;
	background: $white;
}
.navbar-custom-title:empty {
	display: none;
}

.navbar-divider {
	width: 1px;
	height: 40px;
	margin: 0.75rem 0.5rem;
	background-color: $border-color;
}
</style>
